import { useTranslation } from '@rbx/intl';
import React from 'react';

type AssistantIconProps = {
  size: number;
  className: string | undefined;
};

const AssistantIcon = ({ size, className }: AssistantIconProps) => {
  const { translate } = useTranslation();
  return (
    <svg
      className={className}
      width={size}
      height={size}
      aria-label={translate('Label.AssistantIcon')}
      viewBox='0 0 28 28'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.1831 8.2926C13.2446 8.1172 13.4101 7.99982 13.5959 7.99982H14.4041C14.5899 7.99982 14.7554 8.1172 14.8169 8.2926L16.7074 13.6839C16.9713 14.4366 17.5632 15.0285 18.3159 15.2924L23.7073 17.1829C23.8826 17.2444 24 17.4099 24 17.5957V18.4039C24 18.5897 23.8826 18.7553 23.7073 18.8168L18.3159 20.7072C17.5632 20.9712 16.9713 21.563 16.7074 22.3158L14.8169 27.7071C14.7554 27.8824 14.5899 27.9998 14.4041 27.9998H13.5959C13.4101 27.9998 13.2446 27.8824 13.1831 27.7071L11.2926 22.3158C11.0287 21.563 10.4368 20.9712 9.6841 20.7072L4.29273 18.8168C4.11738 18.7553 4 18.5897 4 18.4039V17.5957C4 17.4099 4.11738 17.2444 4.29273 17.1829L9.6841 15.2924C10.4368 15.0285 11.0287 14.4366 11.2926 13.6839L13.1831 8.2926Z'
        fill='currentColor'
      />
      <path
        d='M3.67323 5.11709C3.69782 5.04695 3.76404 5 3.83837 5H4.16163C4.23596 5 4.30218 5.04695 4.32677 5.11709L5.08296 7.27363C5.18854 7.57472 5.42528 7.81146 5.72637 7.91704L7.88291 8.6732C7.95305 8.6978 8 8.764 8 8.8384V9.1616C8 9.236 7.95305 9.3022 7.88291 9.3268L5.72637 10.083C5.42528 10.1885 5.18854 10.4253 5.08296 10.7264L4.32677 12.8829C4.30218 12.953 4.23596 13 4.16163 13H3.83837C3.76404 13 3.69782 12.953 3.67323 12.8829L2.91704 10.7264C2.81146 10.4253 2.57472 10.1885 2.27363 10.083L0.11709 9.3268C0.04695 9.3022 0 9.236 0 9.1616V8.8384C0 8.764 0.04695 8.6978 0.11709 8.6732L2.27363 7.91704C2.57472 7.81146 2.81146 7.57472 2.91704 7.27363L3.67323 5.11709Z'
        fill='currentColor'
      />
      <path
        d='M22.6018 0.11709C22.6264 0.04695 22.6926 0 22.7669 0H23.2331C23.3074 0 23.3736 0.04695 23.3982 0.11709L24.3955 2.96113C24.501 3.26221 24.7378 3.49896 25.0389 3.60454L27.8829 4.6018C27.953 4.62639 28 4.69261 28 4.76694V5.23306C28 5.30739 27.953 5.37361 27.8829 5.3982L25.0389 6.39546C24.7378 6.50104 24.501 6.73778 24.3955 7.03887L23.3982 9.8829C23.3736 9.953 23.3074 10 23.2331 10H22.7669C22.6926 10 22.6264 9.953 22.6018 9.8829L21.6045 7.03887C21.499 6.73779 21.2622 6.50104 20.9611 6.39546L18.1171 5.3982C18.047 5.37361 18 5.30739 18 5.23306V4.76694C18 4.69261 18.047 4.62639 18.1171 4.6018L20.9611 3.60454C21.2622 3.49896 21.499 3.26222 21.6045 2.96113L22.6018 0.11709Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default AssistantIcon;
